import instance from './requst'
export function selectDataset(data){
    return instance.post('/v1/datasets/search',data)
}

export function postDataset(data){
    return instance.post('/v1/datasets',data)
}
export function DelDataset(id){
    return  instance.delete(`/v1/datasets/${id}`)
}
export function addViewNum(id){
    return instance.patch(`/v1/datasets/${id}/incr_view_num`)
}
export function updataDataset(id,data){
    return instance.put(`/v1/datasets/${id}`,data)
}
export function getDataset(id){
    return instance.get(`/v1/datasets/${id}`)
}